import { call, put, takeEvery } from 'redux-saga/effects'

import {
	errorMessage,
	successMessage,
	loadingMessage,
} from '~/services/messager'

import api from '~/services/api'
import {
	getIntegration,
	getIntegrationSuccess,
	getIntegrationFailure,
	saveIntegration,
	saveIntegrationSuccess,
	saveIntegrationFailure,
	getD4sign,
	getD4signSuccess,
	getD4signFailure,
} from '.'

export default function* rootSaga() {
	yield takeEvery(getIntegration, getIntegrationSaga)
	yield takeEvery(saveIntegration, saveIntegrationSaga)
	yield takeEvery(getD4sign, getD4signSaga)
}

function* getIntegrationSaga() {
	try {
		const { data } = yield call(api.get, `/company/info`)
		yield put(getIntegrationSuccess(data))
	} catch (error) {
		yield put(getIntegrationFailure(error))
	}
}

function* saveIntegrationSaga({ payload }) {
	try {
		loadingMessage({
			content: 'Salvando dados...',
			updateKey: 'saveIntegrations',
		})
		if (payload.d4sign) {
			const responseD4sign = yield call(
				api.put,
				`/d4sign/company-info`,
				payload.fields
			)
			successMessage({
				content: 'Dados do D4Sign salvos com sucesso',
				updateKey: 'saveIntegrations',
			})
			yield put(saveIntegrationSuccess(responseD4sign.data))
		}
		// Se for Clicksign, faz a chamada para salvar o access token do Clicksign
		if (payload.clicksign) {
			const responseClicksign = yield call(api.put, `/clicksign/company-info`, {
				clicksign_access_token: payload.fields.clicksign_access_token,
			})
			successMessage({
				content: 'Dados do Clicksign salvos com sucesso',
				updateKey: 'saveIntegrations',
			})
			yield put(saveIntegrationSuccess(responseClicksign.data))
		}
		if (payload.docusign) {
			const responseDocusign = yield call(
				api.put,
				`/docusign/company-info`,
				payload.fields
			)

			successMessage({
				content: 'Dados do DocuSign salvos com sucesso',
				updateKey: 'saveIntegrations',
			})
			yield put(saveIntegrationSuccess(responseDocusign.data))

			const integrationKey = process.env.REACT_APP_DOCUSIGN_INTEGRATION_KEY
			const redirectUri = encodeURIComponent(
				process.env.REACT_APP_DOCUSIGN_REDIRECT_URL
			)
			const scope = encodeURIComponent('signature impersonation')
			const baseAuthUrl = process.env.REACT_APP_DOCUSIGN_OAUTH_URL

			const authUrl = `${baseAuthUrl}/auth?response_type=code&scope=${scope}&client_id=${integrationKey}&redirect_uri=${redirectUri}`
			window.location.href = authUrl
		}

		yield put(getIntegration())
	} catch (error) {
		yield put(saveIntegrationFailure(error))
		errorMessage({
			content: 'Problemas ao salvar dados',
			updateKey: 'saveIntegrations',
		})
	}
}

function* getD4signSaga({ payload }) {
	try {
		const { data } = yield call(api.get, `/d4sign/company-info`, payload)
		yield put(getD4signSuccess(data))
	} catch (error) {
		yield put(getD4signFailure(error))
	}
}
